import { render, staticRenderFns } from "./RoomGeneralInfoTab.vue?vue&type=template&id=052ab49f&"
import script from "./RoomGeneralInfoTab.vue?vue&type=script&lang=js&"
export * from "./RoomGeneralInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./RoomGeneralInfoTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VSubheader,VTextField})
